







import Vue from 'vue';
import LastUpdated from './LastUpdated.vue';
import RefreshBtn from './RefreshBtn.vue';

export default Vue.extend({
  props: {
    emailCampaignId: {
      type: String,
      required: true,
    },
    lastUpdated: {
      type: String,
      required: true,
    },
  },
  components: {
    'last-updated': LastUpdated,
    'refresh-btn': RefreshBtn,
  },
});
